import axios from 'axios'

const userAPI = {
    // Auth
    userRegister(data) {
        return new Promise((resolve, reject) => {
            axios.post('/signup', data, {
                "Authorization": ""
            }).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    userLogin(data) {
        return new Promise((resolve, reject) => {
            axios.post('/customer/login', data, {
                "Authorization": ""
            }).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Inbox
    getInbox(data) {
        return new Promise((resolve, reject) => {
            axios.post('customer/get-unread-notification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getNotification(data) {
        return new Promise((resolve, reject) => {
            axios.post('customer/get-notification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    readStatusUpdate(data) {
        return new Promise((resolve, reject) => {
            axios.post('customer/read-status-update', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getUnreadNotificationCount(data) {
        return new Promise((resolve, reject) => {
            axios.post('customer/get-unread-notification-count', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteNotification(data){
        return new Promise((resolve, reject) => {
            axios.post('customer/delete-notification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Orders
    getOrders(data) {
        return new Promise((resolve, reject) => {
            axios.post('customer/get-orders', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getOrderDetails(data) {
        return new Promise((resolve, reject) => {
            axios.post('customer/get-order-details', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Rating
    addRating(data) {
        return new Promise((resolve, reject) => {
            axios.post('/customer/add-rating', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    dashboardNotification(data) {
        return new Promise((resolve, reject) => {
            axios.post('/customer/dashboard', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
}

export default userAPI
